// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_48-2";
export var blackBorderOnHover = "_48-7";
export var cell = "_48-6";
export var cellContainer = "_48-3";
export var checked = "_48-8";
export var disabled = "_48-5";
export var featuredIconCellContainer = "_48-9";
export var featuredIconTextContainer = "_48-b";
export var featuredIconWrapper = "_48-a";
export var noBorder = "_48-c";
export var orangeSelectedRow = "_ap-3";
export var overflowableText = "_48-0";
export var overflowableTextContainer = "_48-1";
export var row = "_4a-0";
export var rowCheckboxCell = "_48-4";
export var selectableTable = "_ap-2";